import React from 'react';
import { Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import StackIndex from '../StackIndex';
import { motion } from 'framer-motion';

const Root = styled(Grid)(({ theme }) => ({}));

const SectionTitleContainer = styled(Grid)(({ theme }) => ({
	height: '1.8rem',
	overflow: 'hidden'
}));

const SectionTitleWrapper = styled(motion.div)(({ theme }) => ({}));

const SectionTitle = styled(Typography)(({ theme }) => ({
	fontSize: '1.2rem',
	fontWeight: 500
}));

const titles = ['Title & Description', 'Upload Images', 'Publish Your Gallery'];

function CreateGalleryHeader({ index }) {
	return (
		<Root>
			<SectionTitleContainer>
				<SectionTitleWrapper
					animate={{
						y: `-${index * 1.8}rem`
					}}
					initial={{ y: 0 }}
					transition={{
						ease: [0.77, 0, 0.175, 1],
						duration: 0.4
					}}
				>
					{titles.map((title) => (
						<SectionTitle key={title}>{title}</SectionTitle>
					))}
				</SectionTitleWrapper>
			</SectionTitleContainer>
			<StackIndex index={index} />
		</Root>
	);
}

export default CreateGalleryHeader;
